module.exports = __webpack_public_path__ + "a768e7de/img/print-icon.d8dbbca5.svg";